import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { GridConfiguration } from '../../user/models/grid-configuration';
import { DefaultGridConfiguration } from '../../user/models/default-grid-configuration';
import { GridConfigurationService } from '../../user/services/grid-configuration.service';
import { GenericModalService } from '../../shared/generic-modal/generic-modal.service';
import { User } from '../../user/models';
import { UserService } from 'src/app/user/services';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { TrackingSearchViewGridComponent } from '../tracking-search-views-grid/tracking-search-views-grid.component';

@Component({
    selector: 'app-tracking-search-views',
    templateUrl: './tracking-search-views.component.html',
    styleUrls: ['./tracking-search-views.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, TrackingSearchViewGridComponent]
})
export class TrackingSearchViewComponent implements OnInit {
    configs: GridConfiguration[] = [];
    defaultConfigs: GridConfiguration[] = [];
    allUsers: User[] = [];

    constructor(
        private userService: UserService,
        private loadingPanelService: LoadingPanelService,
        private gridConfigurationService: GridConfigurationService,
        private genericModalService: GenericModalService) {
    }

    async ngOnInit(): Promise<void> {
        await this.refresh();
    }

    async refresh(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading views...');
            this.allUsers = await this.userService.getUsers();
            this.defaultConfigs = await this.gridConfigurationService.getDefaultViews('Tracking');
            this.configs = await this.gridConfigurationService.getGridConfigurations(null, 'Tracking', true);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    async onSaveView(config: GridConfiguration): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Saving views...');
            const existing = this.configs.filter(x => x.Name === config.Name);
            if (existing && existing.length > 1) {
                this.genericModalService.messageDirect('Error saving', 'A view with that name already exists.');
            }
            else {
                const saved = await this.gridConfigurationService.saveGridConfiguration(config);
                if (config.IsDefault) {
                    await this.setDefault(config);
                }
                else {
                    await this.removeDefault(config);
                }
                config.Id = saved.Id;
            }
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
        this.refresh();
    }

    async onDeleteView(view: GridConfiguration): Promise<void> {
        await this.gridConfigurationService.deleteGridConfiguration(view.Id);
        this.refresh();
    }

    async setDefault(view: GridConfiguration): Promise<void> {
        await this.gridConfigurationService.setDefaultView({ GridConfigurationId: view.Id, Key: 'Tracking' } as DefaultGridConfiguration);
        this.refresh();
    };

    async removeDefault(view: GridConfiguration): Promise<void> {
        await this.gridConfigurationService.removeDefaultView({ GridConfigurationId: view.Id, Key: 'Tracking' } as DefaultGridConfiguration);
        this.refresh();
    };
}
